import fetch from 'isomorphic-fetch';

let ENDPOINT_URL = process.env.VUE_APP_FLOTA_DELETE;
async function deleteUnit(id) {
  const bodyParams = {
    _id: id._id,
    token: localStorage.getItem('token'),
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { deleteUnit };
